// Guest cart kept in the browser (localStorage). Merges into the server cart on login.
const KEY = "suffle_guest_cart";

const read = () => { try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; } };
const write = (items) => { localStorage.setItem(KEY, JSON.stringify(items)); window.dispatchEvent(new Event("cart-updated")); };

export const guestCartItems = () => read();
export const guestCartCount = () => read().reduce((n, i) => n + (i.qty || 0), 0);

export const addGuestItem = (product_id, qty = 1, variant_vid = null) => {
  const items = read();
  const ex = items.find((i) => i.product_id === product_id && (i.variant_vid || null) === (variant_vid || null));
  if (ex) ex.qty += qty; else items.push({ product_id, qty, variant_vid: variant_vid || null });
  write(items);
  return guestCartCount();
};

export const clearGuestCart = () => { localStorage.removeItem(KEY); window.dispatchEvent(new Event("cart-updated")); };

export const setGuestQty = (product_id, variant_vid, qty) => {
  const items = read();
  const it = items.find((i) => i.product_id === product_id && (i.variant_vid || null) === (variant_vid || null));
  if (it) { it.qty = Math.max(1, qty); write(items); }
};

export const removeGuestItem = (product_id, variant_vid) => {
  write(read().filter((i) => !(i.product_id === product_id && (i.variant_vid || null) === (variant_vid || null))));
};

export const mergeGuestCartToServer = async (api) => {
  const items = read();
  if (!items.length) return;
  for (const it of items) {
    try { await api.post("/marketplace/cart/add", { product_id: it.product_id, qty: it.qty, variant_vid: it.variant_vid }); } catch { /* skip bad item */ }
  }
  clearGuestCart();
};
